<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M6.65 13.32C7.5 14.18 8.69 14.71 9.99 14.71C11.29 14.71 12.47 14.18 13.32 13.33M9.99 1.94C7.85501 1.94 5.80746 2.78813 4.29779 4.29779C2.78813 5.80746 1.94 7.85501 1.94 9.99C1.94 11.45 2.34 12.82 3.02 14C3.5 14.89 2.96 17.01 1.94 18.04C3.33 18.12 5.16 17.49 5.98 16.96C7.19793 17.6676 8.58144 18.0402 9.99 18.04C12.125 18.04 14.1725 17.1919 15.6822 15.6822C17.1919 14.1725 18.04 12.125 18.04 9.99C18.04 7.85501 17.1919 5.80746 15.6822 4.29779C14.1725 2.78813 12.125 1.94 9.99 1.94Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
